/* eslint-disable no-use-before-define */
// global grecaptcha, Cookie
// DATE PICKER SHOULD INCLUDE THE SCRIPTS BELLOW from https://flatpickr.js.org/getting-started/
// <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css">
// <script src="https://cdn.jsdelivr.net/npm/flatpickr"></script>

((window, document) => {
  const isNewEnquiryForm = Boolean(
    document.getElementById('form_92') || document.getElementById('form_66'),
  );

  // Select the header and store it's height
  const header =
    document.querySelector('.site-nav-container') ||
    document.querySelector('.primary-nav') ||
    document.querySelector('.site-primary-nav-container');

  const HeaderHeight = header.getBoundingClientRect().height;

  // Select the thank you message
  const thankYouMessage = document.querySelector('.js-thank-you');

  /**
   * Store all the regex patterns, can store patterns and functions that return true | false
   * The functions should return true if it is successfull or false if it failed
   */

  const regexPatterns = {
    phoneUK:
      /^((\(?0\d{4}\)?\s*\d{6}\s*)|(\s*\(?0\d{3}\)?\s*\d{3}\s*\d{4})|(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3})$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
    ukpostcode: /^[a-zA-Z]{1,2}[0-9][0-9A-Za-z]{0,1} {0,1}[0-9][A-Za-z]{2}$/,
    name: /^([a-z,.'-]+\s?)+$/i,
    date: /^(\d{2})\/(\d{2})\/(\d{4})?$/,
    sortcode: /^[0-9][0-9]-?[0-9][0-9]-?[0-9][0-9]$/,
    password: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[#?!@$%^&*\-+£=<>~]).{8,}$/,
  };

  /**
   *  * Error messages for different input types.
   * Add by attaching a 'js-validate-type' class to the input, i. e. js-validate-password.
   */

  const errorMessages = {
    password: `Your password must have at least 8 characters, contain at least 1 number, at least 1 capital letter,
      at least 1 lower case letter, and at least 1 character that isn't an alphanumeric character.`,
    email: 'Please enter a valid email address',
  };

  /**
   * Store all the initialized forms in order to modify them in runtime
   * @type {{ [key: string]: Validator }}
   */

  const initializedForms = {};
  /**
   * Store the update forms options to be used after form initialization
   * @type {{ [key: string]: ValidateOptions }}
   */

  const updateFormsAfterInit = {};

  /**
   * Add a method or a pattern to regex patterns
   * @param {string} name The key name to add to the regex patterns
   * @param {RegExp|function} value The value to add to the key a pattern or a function */

  function addMethod(name, value) {
    regexPatterns[name] = value;
  }

  /**
   * Set the value of an input element. We will also fire a blur event so that
   * the form is validated after a change.
   * @param {HTMLInputElement} inputEl The input element
   * @param {string} value The value to set
   */
  function setInputValue(inputEl, value = '') {
    // Check if input el is passed
    if (inputEl) {
      inputEl.value = value;

      // Fire a blur event for the form utilities to update the classes of the inputs
      if ('fireEvent' in inputEl) {
        // IE
        inputEl.fireEvent('onblur');
      } else if (typeof window.Event === 'function') {
        // Modern browsers
        inputEl.dispatchEvent(new Event('blur'));
      } else {
        // Older browsers
        const evObj = document.createEvent('Event');
        evObj.initEvent('blur', true, true);
        inputEl.dispatchEvent(evObj);
      }
    }
  }

  /**
   * Smooth scroll to a top position
   * @param {number} top The top scroll y to scroll
   */
  function smoothScrollTo(top) {
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollBy({
        top,
        behavior: 'smooth',
      });
    } else {
      window.scrollBy(0, top);
    }
  }

  /**
   * Hide the error message of an input element
   * @param {HTMLInputElement} input - The input element to remove the error message
   */
  function hideErrorMessage(input) {
    try {
      input.parentNode.classList.remove('form--invalid');

      if (input.type === 'radio') {
        const allRadios = document.querySelectorAll(`input[name=${input.name}]`);
        for (let i = 0, len = allRadios.length; i < len; i += 1) {
          allRadios[i].parentNode.classList.remove('form--invalid');
        }
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn(err);
    }
  }

  /**
   * Sets the text of the error container.
   * If exists, uses the predefined message of
   * @constant errorMessages
   * @param {HTMLInputElement} input
   * @param {HTMLDivElement} errorContainer
   * @param {string} fieldName
   */

  function setErrorMessage(input, errorContainer, fieldName) {
    let errorContainerTextContent;

    if (input.classList.value.match(/js-validate-([a-zA-Z0-9]+)/)) {
      const type = input.classList.value.match(/js-validate-([a-zA-Z0-9]+)/)[1];
      if (type && errorMessages[type]) {
        if (isNewEnquiryForm) {
          errorContainerTextContent = `
              <svg class="icon">
                  <use xlink:href="#globalCircleXMark"></use>
              </svg>
              ${errorMessages[type]}
            `;
          errorContainer.innerHTML = errorContainerTextContent;
        } else {
          errorContainer.textContent = errorMessages[type];
        }
        return;
      }
    }

    errorContainerTextContent = `Please input a valid ${fieldName
      .toLowerCase()
      .replace(/^this/i, '')}`;

    if (isNewEnquiryForm) {
      errorContainer.innerHTML = `
            <svg class="icon">
                <use xlink:href="#globalCircleXMark"></use>
            </svg>
            ${errorContainerTextContent}
        `;
    } else {
      errorContainer.textContent = errorContainerTextContent;
    }
  }

  /**
   * Show the error message of an input element
   * @param {HTMLInputElement} input - The input element to remove the error message
   * @param {'required'|'pattern'} rule - The rule that failed
   */
  function showErrorMessage(input, rule) {
    try {
      const inputContainer =
        input.name === 'hiddenRecaptcha'
          ? input.parentNode.querySelector('.recaptcha_element')
          : input.parentNode;
      let errorContainer = inputContainer.querySelector('.form__message--error');
      const inputLabel = inputContainer.querySelector('label');

      // Store the field name
      let fieldName;

      // If the input doesnt have a label or it is a checkbox
      if (!inputLabel || input.type === 'checkbox') {
        // Get the placeholder as a field name or add this field
        fieldName = input.placeholder ? input.placeholder.replace(/\s?:?\*?:?$/, '') : 'This field';
      } else {
        fieldName = inputLabel.textContent.replace(/\s?:?\*?:?$/, '');
      }

      if (!errorContainer) {
        inputContainer.classList.add('form__element', 'form--untouched');
        errorContainer = document.createElement('div');
        errorContainer.className = 'form__message form__message--error';
        inputContainer.appendChild(errorContainer);
      }

      if (rule === 'required') {
        if (isNewEnquiryForm) {
          errorContainer.innerHTML = `
                <svg class="icon">
                    <use xlink:href="#globalCircleXMark"></use>
                </svg>
                ${fieldName} is required
            `;
        } else {
          errorContainer.textContent = `${fieldName} is required`;
        }
      } else {
        setErrorMessage(input, errorContainer, fieldName);
      }

      inputContainer.classList.add('form--invalid');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.warn(err);
    }
  }

  // Module class declarations

  class ValidateOptions {
    /**
     * The constructor for the validator options
     * @param {string} ignore - The input class that will be ignored
     * @param {Object} rules - The inputs rules to check
     * @param {(event) => void} submitHandler - The submit handler to be called if form is valid
     * @param {(errors) => void} invalidHandler - The handler to run when a form submition fails
     * @param {HTMLFormElement} form - The form element of the options set
     */
    constructor({ ignore = 'ignore', rules = {}, submitHandler, invalidHandler }, form = null) {
      this.ignore = ignore;
      this.rules = rules;
      this.submitHandler = submitHandler;
      this.invalidHandler = invalidHandler;

      if (typeof rules.hiddenRecaptcha === 'undefined') {
        this.rules.hiddenRecaptcha = {
          required() {
            if (
              grecaptcha.getResponse(
                form.querySelector('.recaptcha_element').getAttribute('data-widget-id'),
              ) === ''
            ) {
              return true;
            }
            return false;
          },
        };
      }
    }
  }

  class Validator {
    /**
     * Initialize the validator to handle form validation
     * @param {string} id - The form id to validate
     * @param {ValidateOptions} [options={}] - The options to be used for the validation
     */
    constructor(id, options) {
      if (!id) {
        // eslint-disable-next-line no-console
        console.warn('Validator: An id is required for validating.');
        return;
      }

      // Select the form
      const form = document.getElementById(id);

      // If the form is not found return
      if (!form) {
        // eslint-disable-next-line no-console
        console.warn('Validator: The form was not found.');
        return;
      }

      // Store the form that the validation was added
      this.form = form;
      this.submited = false;

      // Initialize the validate options
      this.vOptions = new ValidateOptions(options, form);

      // Bind methods to the class
      this.submitHandler = this.submitHandler.bind(this);
      this.blurHandler = this.blurHandler.bind(this);
      this.focusHandler = this.focusHandler.bind(this);

      // Add the submit handler to the form
      form.addEventListener('submit', this.submitHandler);

      this.initializeForm(form);
    }

    initializeForm(form) {
      try {
        const formElements = form.querySelectorAll('input[name], textarea[name], select[name]');

        const submitBtn = form.querySelector('input[type=submit]');

        if (submitBtn && submitBtn.value === 'submit') {
          submitBtn.value = 'Submit';
        }

        for (let i = 0, len = formElements.length; i < len; i += 1) {
          const input = formElements[i];
          const isVisibleInput = input.type !== 'hidden' && !input.hidden;

          // If the input is hidden dont add event listener
          if (isVisibleInput) {
            // Get the input container
            const inputContainer = input.parentNode;

            if (!isNewEnquiryForm) {
              // Remove the placeholder attribute
              input.removeAttribute('placeholder');
            }

            // Check if the input has a value to add the dirty-class for the placeholder
            if (input.value && input.value !== '' && input.type !== 'checkbox') {
              inputContainer.classList.add('form--dirty');

              if (this.vOptions.rules[input.name] && this.vOptions.rules[input.name].required) {
                inputContainer.classList.remove('form--untouched');
              }
            }
          }
        }

        form.addEventListener('blur', this.blurHandler, true);
        form.addEventListener('focus', this.focusHandler, true);

        setTimeout(() => form.blur(), 15);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
      }
    }

    /**
     * Remove the form validation in order to create a new one if needed
     */
    removeValidation() {
      this.form.removeEventListener('submit', this.submitHandler);
      this.form.removeEventListener('blur', this.blurHandler, true);
      this.form.removeEventListener('focus', this.focusHandler, true);
    }

    blurHandler(event) {
      const input = event.target;
      const inputContainer = input.parentNode;

      if (!this.checkPurity(input)) {
        showErrorMessage(input, 'insecure');
      } else {
        hideErrorMessage(input);
      }

      if (this.vOptions.rules[input.name]) {
        const rulesResults = this.checkRules(input, this.vOptions.rules[input.name]);
        if (rulesResults.valid) {
          hideErrorMessage(input);
        } else {
          showErrorMessage(input, rulesResults.rule);
        }

        if (this.vOptions.rules[input.name].required) {
          inputContainer.classList.remove('form--untouched');
        }
      }

      // Check if the input has a value
      if (input.name && input.value && input.value !== '') {
        inputContainer.classList.add('form--dirty');
      } else {
        inputContainer.classList.remove('form--dirty');

        if (input.nodeName === 'SELECT') {
          inputContainer.classList.add('form--untouched');
        }
      }
    }

    focusHandler(event) {
      if (this.vOptions.rules[event.target.name]) {
        event.target.parentNode.classList.remove('form--invalid');

        if (event.target.nodeName !== 'SELECT') {
          event.target.parentNode.classList.add('form--untouched');
        }
      }

      if (event.target.nodeName === 'SELECT') {
        event.target.parentNode.classList.add('form--dirty');
        event.target.parentNode.classList.remove('form--untouched');
      }
    }

    setDataLayer() {
      const vdDealTerms = JSON.parse(window.sessionStorage.getItem('_vdDealTerms'));
      const { mileage } = vdDealTerms;
      const { payment } = vdDealTerms;
      const type = vdDealTerms.paymentType;
      const cashPrice = vdDealTerms.price;
      const contract = vdDealTerms.term;
      let dataLayerEventName = '';

      if (window.location.href.includes('enquire')) {
        dataLayerEventName = 'formSubmit';
      }

      if (window.location.href.includes('request-a-callback')) {
        dataLayerEventName = 'instantCallback';
      }

      window.dataLayer.push({
        event: dataLayerEventName,
        product: {
          cashPrice,
        },
        annual: {
          mileage,
        },
        payment: {
          type,
        },
        length: {
          contract,
        },
        initial: {
          payment,
        },
        includes: {
          maintenance: !vdDealTerms.maintenance ? false : vdDealTerms.maintenance,
        },
        promo: {
          code: window.sessionStorage.getItem('promoCode')
            ? JSON.parse(window.sessionStorage.getItem('promoCode'))
            : '',
        },
      });
    }

    /**
     * Set the input value with the cookie value
     * @param {Type} type - The type of element
     * @param {Name} name - The name of the target element
     * @param {Cookie} cookie - The name of the cookie
     */
    setInputCookieValue(type, name, cookie) {
      document.querySelector(`${type}[name="${name}"]`).value = Cookie.get(`${cookie}`);
    }

    /**
     * Handle the form submition
     * @param {Event} event - The event occured from submiting the form
     */
    submitHandler(event) {
      // Prevent the default submition
      event.preventDefault();

      if (!this.submited) {
        this.submited = true;

        const formValues = this.getFormValues(event.target, this.vOptions);

        // If no errors were found
        if (formValues.values !== null && !formValues.errors.length) {
          if (
            window.location.href.includes('vansdirect') &&
            window.sessionStorage.getItem('_vdDealTerms')
          ) {
            this.setDataLayer();
          }

          try {
            if (window.anniversary === true) {
              const d = new Date();
              d.setTime(d.getTime() + 1 * 60 * 1000);
              const expires = d.toGMTString();
              document.cookie = `anniversarySubmit = true; expires = ${expires};`;
            }
          } catch (err) {
            // eslint-disable-next-line no-console
            console.warn(err);
          }
          // Set the GA cookie to the input element
          // Set the Google Client ID for enquiry tracking
          // Set the My Car Status for enquiry tracking
          try {
            this.setInputCookieValue('input', 'Q626', '_ga');
            this.setInputCookieValue('input', 'Q651', '_ga');
            this.setInputCookieValue('input', 'Q652', 'mcSess');
          } catch (err) {
            // eslint-disable-next-line no-console
            console.warn(err);
          }

          // If the submit handler is passed as option the call that isntead of submiting the form
          if (typeof this.vOptions.submitHandler === 'function') {
            this.vOptions.submitHandler(event, formValues, this);
          } else {
            event.target.submit();
          }
        } else {
          // If we have a form handler for invalid form submition
          if (typeof this.vOptions.invalidHandler === 'function') {
            this.vOptions.invalidHandler(formValues.errors);
          }

          this.submited = false;
        }
      }
    }

    /**
     * Get the form values
     * @param {HTMLFormElement} form - The form to get the values from
     * @param {ValidateOptions} options - The form validation options
     * @return {Object}
     */
    getFormValues(form, options) {
      const values = {};
      // Store the form errors
      const errors = [];

      if (!form) {
        return { values: null, errors };
      }

      // Get the inputs of the form
      const inputs = form.querySelectorAll('input[name], textarea[name], select[name]');

      // Loop through all inputs
      for (let i = 0, len = inputs.length; i < len; i += 1) {
        const input = inputs[i];

        // Check if the input has an ingore class and continue if so
        if (input.classList.contains(options.ignore)) {
          continue;
        }

        // If the input is the action input then add the submit as an action
        if (input.name === 'action') {
          input.value = 'submit';
        }

        // Check if the input is not clean
        if (!this.checkPurity(input)) {
          showErrorMessage(input, 'insecure');
          smoothScrollTo(form.getBoundingClientRect().top - (HeaderHeight + 20));
          // An invalid input was found push the error
          errors.push({
            [input.name]: `${input.name.toLowerCase()} is invalid.`,
          });
          continue;
        }

        // If there is a rule for the input
        const rulesResults = this.checkRules(input, options.rules[input.name]);
        if (options.rules[input.name] && rulesResults && !rulesResults.valid) {
          // Display the error message
          showErrorMessage(input, rulesResults.rule);

          smoothScrollTo(form.getBoundingClientRect().top - (HeaderHeight + 20));

          // An invalid input was found push the error
          errors.push({
            [input.name]:
              input.name.toLowerCase() +
              (rulesResults.rule === 'required' ? ' is required.' : ' is invalid.'),
          });

          continue;
        }

        // Check if the checkbox is checked
        if (input.type === 'checkbox' && !input.checked) {
          continue;
        }

        if (input.type === 'radio' && !input.checked) {
          continue;
        }

        // Add the input value to the values
        values[input.name] = input.value;
      }

      try {
        vm.debug.log({ values, errors });
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
      }

      // Return null if the form is not valid
      return { values, errors };
    }

    /**
     * Check if the element's input is pure
     * @param {HTMLInputElement} input - The input element to check.
     * @returns {boolean} Whether or not the input is clean.
     */
    checkPurity(input) {
      // applies to all inputs, EXCEPT THE FOLLOWING:
      const isFlatpickr = input.className.includes('flatpickr');
      const isAnchor = input instanceof HTMLAnchorElement;
      const isButton = input instanceof HTMLButtonElement;
      const isRecaptcha = input instanceof HTMLIFrameElement && input.title === 'reCAPTCHA';
      // list exceptions for the purify fx
      if (isFlatpickr || isAnchor || isButton || isRecaptcha) return true;
      // check if input has nefarious content; throw 'insecure' error if so
      // which will simply throw "Please input a valid INPUTNAMEHERE" to the user
      try {
        const { DOMPurify } = window;
        const stringCleaned = DOMPurify.sanitize(input.value);
        const isClean = stringCleaned === input.value;
        return isClean;
      } catch (error) {
        // If you see this warning, the page needs the DOMPurify module
        // leaving this message somewhat vague, as outsiders dont need
        // to know what exactly is missing
        // eslint-disable-next-line no-console
        console.warn('WARNING: Missing script for form-utilities.js.');
        // assume pure ...
        return true;
      }
    }

    /**
     * Check if the element rules are valid
     * @param {HTMLInputElement} input - The input element to check.
     * @param {Object} rules - The input rules
     */
    checkRules(input, rules) {
      const valid = { valid: true, rule: '', name: input.name };

      if (!rules) {
        return valid;
      }

      // Loop through each of the rules and check their type
      const ruleKeys = Object.keys(rules);
      for (let i = 0; i < ruleKeys.length; i += 1) {
        const ruleKey = ruleKeys[i];
        const results = this.checkRuleInput(input, ruleKey, rules[ruleKey]);

        // Check if the chekcRuleInput results are not valid
        if (!results.valid) {
          return results;
        }
      }

      return valid;
    }

    /**
     * Check a rule to an input element
     * @param {HTMLInputElement} input - The input element to check.
     * @param {string} ruleKey - The rule key (required | pattern)
     * @param {string|function|RegExp} ruleValue The rule assinged to the key
     */
    checkRuleInput(input, ruleKey, ruleValue) {
      // Check if the rule is required
      if (ruleKey === 'required') {
        // Check all possible conditions for an input to be invalid
        const requiredFunction =
          typeof ruleValue === 'function' && ruleValue(input) && input.value === '';

        if (requiredFunction) {
          return { valid: false, rule: ruleKey, name: input.name };
        }

        const requiredCheckbox = input.type === 'checkbox' && !input.checked && ruleValue;
        const requiredInput =
          input.type !== 'checkbox' && input.type !== 'radio' && input.value === '' && ruleValue;
        let requiredRadio = input.type === 'radio' && !input.checked && ruleValue;

        if (requiredRadio) {
          const allRadios = document.querySelectorAll(`input[name=${input.name}]`);

          let checked = false;
          let i = 0;

          while (!checked && i < allRadios.length) {
            checked = allRadios[i].checked;
            if (checked) {
              break;
            }
            i += 1;
          }

          // If the radio is not checked and it is required
          requiredRadio = !checked && ruleValue;
        }

        if (
          typeof ruleValue !== 'function' &&
          (requiredCheckbox || requiredInput || requiredRadio)
        ) {
          return { valid: false, rule: ruleKey, name: input.name };
        }
      }

      // Check if the rule is a pattern
      if (ruleKey === 'pattern') {
        // Check if the input is not required
        if (!this.vOptions.rules[input.name].required && input.value === '') {
          return { valid: true, rule: ruleKey, name: input.name };
        }

        // Check if the rule is a function then call it if it returns false then return false
        if (typeof ruleValue === 'function' && !ruleValue(input)) {
          return { valid: false, rule: ruleKey, name: input.name };
        }

        // Check if the pattern is a regex
        if (ruleValue instanceof RegExp) {
          return {
            valid: ruleValue.test(input.value),
            rule: ruleKey,
            name: input.name,
          };
        }

        // Check if the pattern is a string and it exists in the regex patters
        if (typeof ruleValue === 'string' && regexPatterns[ruleValue]) {
          // If the regex patterns is a regex instance
          if (regexPatterns[ruleValue] instanceof RegExp) {
            return {
              valid: regexPatterns[ruleValue].test(input.value),
              rule: ruleKey,
              name: input.name,
            };
          }

          // If the regex pattern is a function and the function returns false
          if (typeof regexPatterns[ruleValue] === 'function' && !regexPatterns[ruleValue](input)) {
            return { valid: false, rule: ruleKey, name: input.name };
          }
        }
      }

      return { valid: true, rule: ruleKey, name: input.name };
    }
  }

  /**
   * Update the form options by the provided id
   * @param {string} id The form id to update
   * @param {ValidateOptions} options The options to update
   */
  function updateFormOptions(id, options) {
    if (Object.prototype.hasOwnProperty.call(initializedForms, id)) {
      const newOptions = Object.assign(Object.create(null), initializedForms[id].vOptions, options);
      initializedForms[id].vOptions = newOptions;

      delete updateFormsAfterInit[id];
    } else {
      updateFormsAfterInit[id] = options;
    }
  }

  /**
   * Intialize the validator to handle the form submition
   * @param {string} id The form id to add validation
   * @param {ValidateOptions} options The options to be used for validation
   */
  function initValidator(id, options) {
    // If form is already initialized remove all handlers
    if (Object.prototype.hasOwnProperty.call(initializedForms, id)) {
      initializedForms[id].removeValidation();
    }

    // Renitialized and check if updateFormOptions was called
    initializedForms[id] = new Validator(id, options);

    if (Object.prototype.hasOwnProperty.call(updateFormsAfterInit, id)) {
      updateFormOptions(id, updateFormsAfterInit[id]);
    }

    return initializedForms[id];
  }

  /**
   * Collect dataLayer from previous pages and push into current dataLayer
   */
  function readAndPushDataLayer() {
    const tempDataLayer = JSON.parse(sessionStorage.getItem(`${window.location.hostname}dl`));
    if (tempDataLayer) {
      Object.keys(tempDataLayer).forEach((data) => {
        const obj = {};
        obj[data] = tempDataLayer[data];
        window.dataLayer.push(obj);
      });
    }
  }

  vm.onload(() => {
    readAndPushDataLayer();

    // Check if the thank you message exists
    if (thankYouMessage) {
      smoothScrollTo(thankYouMessage.getBoundingClientRect().top - (HeaderHeight + 20));
    }
  });

  // Make validator functionalities available globally
  window.validator = {
    validate: initValidator,
    addMethod,
    showErrorMessage,
    updateFormOptions,
    regexPatterns,
    errorMessages,
    forms: initializedForms,
    setInputValue,
  };
})(window, document);
